
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stream-ultra-home-solar-system/specs",
      function () {
        return require("private-next-pages/stream-ultra-home-solar-system/specs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stream-ultra-home-solar-system/specs"])
      });
    }
  